import React from 'react';
import PropTypes from 'prop-types';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { CPButton } from './styles';

export function OneLeftButton({
  content, onClick, disabled, title,
}) {
  return (
    <CPButton
      onClick={onClick}
      disabled={disabled}
      content={content}
      icon={faAngleLeft}
      title={title}
    />
  );
}

OneLeftButton.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  title: PropTypes.string,
};

OneLeftButton.defaultProps = {
  onClick: () => null,
  content: '',
  disabled: false,
  title: '',
};

export default OneLeftButton;
